// material-ui
import Typography from '@mui/material/Typography';
import DirhamIcon from '../../assets/images/logo-xion.png';


// ==============================|| LOGO ||============================== //

export default function LogoMain() {
  return (
    <img src={DirhamIcon} alt="Logo" width='150px' />
  );
}
